var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCsvWarning = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 50",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M22 1H5a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V16L22 1Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 0.5,
  d: "M37.25 45A4.25 4.25 0 0 1 33 49.25H5A4.25 4.25 0 0 1 .75 45V5A4.25 4.25 0 0 1 5 .75h17l.049.005a.25.25 0 0 1 .128.068l15 15a.25.25 0 0 1 .073.177v29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8B923",
  d: "M17.276 24.93c.773-1.314 2.675-1.314 3.448 0l6.503 11.056C28.011 37.319 27.05 39 25.503 39H12.497c-1.547 0-2.508-1.68-1.724-3.014l6.503-11.055Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.25 33v-4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 35.75,
  r: 0.5,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.83 15.83 22.17 1.17a.1.1 0 0 0-.17.071V12a4 4 0 0 0 4 4h10.759a.1.1 0 0 0 .07-.17Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 19,
  x2: 19,
  y1: 1,
  y2: 49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F9FBFC"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h38v50H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  width: 22.859,
  height: 22.858,
  x: 18,
  y: -1.858,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10832_4920"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_10832_4920",
  result: "effect2_dropShadow_10832_4920"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_10832_4920",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCsvWarning);
export default ForwardRef;